<template>    
    <Page header="Курсы">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <RatesList />
            </div>
        </template>
    </Page>
</template>

<script>
import RatesList from '@/components/merchant/RatesList.vue'
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        RatesList,
        Page
    },
}
</script>